export class Gamesocket {
  private static instance: WebSocket | null = null;
  constructor() {}
  
  private static instantiateSocket(
    gameURL: string,
    eventID: string,
    {
      onMessage,
      onClose,
      onOpen,
      onError,
    }: {
      onMessage: (data: any) => void;
      onClose?: (event?: CloseEvent) => void;
      onOpen?: () => void;
      onError?: (event: Event) => void;
    },
  ) {
    // Hard-coded orgID as requested
    const orgID = 1;
    
    // New direct WebSocket URL
    const wsUrl = `wss://ws.test-euler-frontend.com/api/v1/gamesocket/${orgID}/${eventID}`;
    
    console.debug(`Connecting to WebSocket: ${wsUrl}`);
    const socket = new WebSocket(wsUrl);

    socket.onopen = () => {
      onOpen && onOpen();
      console.debug(`Gamesocket opened for event: ${eventID}`);
    };

    socket.onclose = (event) => {
      console.debug(`Gamesocket closed for event: ${eventID}. Code: ${event.code}, Reason: ${event.reason}`);
      onClose && onClose(event);
    };

    socket.onerror = (event) => {
      console.error(`Gamesocket error for event: ${eventID}`, event);
      onError && onError(event);
    };

    socket.onmessage = async (event) => {
      try {
        const data = JSON.parse(event.data);
        onMessage(data);
      } catch (error) {
        console.error('Error parsing message:', error, event.data);
      }
    };
    
    Gamesocket.instance = socket;
  }
  
  public static getInstance(
    gameURL: string,
    eventID: string,
    config: {
      onMessage: (data: any) => void;
      onClose?: (event?: CloseEvent) => void;
      onOpen?: () => void;
      onError?: (event: Event) => void;
    },
  ) {
    // Close existing connection if it exists
    if (Gamesocket.instance !== null) {
      Gamesocket.instance.close();
      Gamesocket.instance = null;
    }
    
    // Create new connection
    this.instantiateSocket(gameURL, eventID, config);
    return Gamesocket.instance;
  }
  
  public static closeConnection() {
    if (Gamesocket.instance !== null) {
      Gamesocket.instance.close();
      Gamesocket.instance = null;
      return true;
    }
    return false;
  }
}